import { createConsumer } from "@rails/actioncable"
import TextLengthCounter from '../../../components/text_length_counter'
import { GeoLocation } from '../../../components/geo_location'

const DURATION_DROP_DOWN_VALUES = {
  ONE_WEEK: 1,
  TWO_WEEKS: 2,
  ONE_MONTH: 3,
  THREE_MONTHS: 4,
  SIX_MONTHS: 5,
  ONE_YEAR: 6,
  MORE_THAN_ONE_YEAR: 7
};

const MESSAGE_ACK_TIMEOUT = 30*1000; // initial ack timeout
const AI_RESPONSE_TIMEOUT = 60*1000; // final response timeout
const REPLAY_LAST_MESSAGE_RESPONSES_COMMAND = 'replay_last_message_responses'

UC.partials.LiveChat = Backbone.View.extend({
  liveChatMessageTemplate: UC.views.resolveHandlebarsTemplate('public/jobs/live_chat_message'),

  events: {
    'click #preview-summary-link' : 'previewSummaryLinkClicked',
    'click #hide-summary-link' : 'hideSummaryLinkClicked',
    'click #send-message-button' : 'sendMessageButtonClicked',
    'keypress #chat-message-input': 'handleEnterPress',
    'change #job-zip-code': 'onZipCodeChanged',
    'input #chat-message-input': 'autoResizeInputTextArea',
  },

  routes: {
    validZipCode: '/account/valid_zip_code/'
  },

  initialize: function() {
    const startMessage = "Hi there, I'm Rachel, your legal e-assistant. I will assist you in collecting your job details and getting our most qualified attorneys to help you. Please share a basic description of your legal needs.";

    this.pajContainer = $('#paj-container');
    this.pajContainer.css({
      'transition': 'all 0.1s ease',
      'width': '100%'
    });
    this.pajContainer.addClass('live-chat-container col-lg-12 col-md-12 col-sm-12');

    this.headerRow = $('#header-row');
    this.headerRow.css({
      'position': 'relative'
    });

    this.chatMessageInput = $('#chat-message-input');
    this.chatContainer = $('.chat-bot-conversation');

    const $affixPanels = $('.header-row .items');
    const affixAvailable = typeof $affixPanels.affix === 'function';
    if (affixAvailable) {
      const $chatPanel = $('.chat-bot-panel:visible');
      $affixPanels.css('width', $chatPanel.width());

      $affixPanels.affix({
        offset: {
          top: $chatPanel.offset().top,
        }
      });

      $(window).resize(function() {
        $affixPanels.css('width', $('.chat-bot-panel:visible').width());

        if (affixAvailable) {
          $affixPanels.affix('checkPosition');
        }

        if (!UC.browser.isMobile() && $('#job-summary-panel:visible').length) {
          this.hideSummaryLinkClicked()
        }
      }.bind(this));
    }

    this.appendMessage('typing');
    this.toggleSendMessageControlsAvailability(false);

    this.consumer = createConsumer();
    this.online = false;
    this.initialized = false;
    this.jobSummary = null;
    this.jobLocation = null;
    this.chatBotMessagesQueue = [];
    this.firstMessageData = {
      message: startMessage,
      from: 'AI',
      summary: {},
      display_chat_message: true
    };
    this.sentOfflineMessage = null;

    const $liveChat = this;

    this.chatChannel = this.consumer.subscriptions.create({
      channel: "JobChannel",
      lead_id: UC.constants.jobLeadId,
    }, {
      connected: (connection_status) => {
        console.log("Connected to the JobChannel");
        $liveChat.online = true;
        if (!$liveChat.initialized) {
          // to avoid greeting messages when re-connected
          $liveChat.initialized = true;

          // Send first message from AI manually
          $liveChat.chatBotMessagesQueue.push(this.firstMessageData);
          $liveChat.popChatBotMessage();
          $liveChat.chatMessageInput.focus();
        } else if ($liveChat.sentOfflineMessage) {
          // resend message saved due to connection lost
          const message = $liveChat.sentOfflineMessage;
          $liveChat.onAckChatMessage();
          $liveChat.chatChannel.sendMessage(message);
        } else if (connection_status.reconnected && $liveChat.inFlightMessage) {
          $liveChat.chatChannel.sendMessage(REPLAY_LAST_MESSAGE_RESPONSES_COMMAND);
        }
      },
      received: (data) => {
        // Handle received data from AI
        if (data.ack) {
          $liveChat.onAckChatMessage();
          return
        }
        $liveChat.resetResponseMessageTimeout();
        $liveChat.inFlightMessage = false;
        if (data.message && data.display_chat_message) {
          $liveChat.chatBotMessagesQueue.push(data);
          $liveChat.popChatBotMessage();
        }
        if (data.summary && !data.display_chat_message) {
          $liveChat.updateSidebar(data.summary);
        }
      },
      disconnected: () => {
        // Add call to disconnected when save/next button is clicked and job_lead stage is updated to closed
        // Handle disconnection
        console.log("Chat service disconnected.");
        $liveChat.online = false;
      },

      sendMessage: function(message) {
        $liveChat.onOfflineChatMessage(message);
        if ($liveChat.online) {
          $liveChat.inFlightMessage = message !== REPLAY_LAST_MESSAGE_RESPONSES_COMMAND;
          this.perform('receive', {message: message, assistant_type: 'v6'});
        } else {
          console.log("You're offline, message will be sent once you'll be back online.");
        }
      }
    });

    this.descriptionLengthCounter = new TextLengthCounter({
      el: this.$el,
      errorContainer: '.form-group',
      textarea: '#job-description',
      counter: '.js-description-length'
    })

    this.$zipCode = $('#job-zip-code');

    // To show the summary from the initialization point onwards
    this.showSummary();
  },

  onOfflineChatMessage: function(message) {
    this.sentOfflineMessage = message;
    this.ackMessageTimeoutId = setTimeout(this.onMessageResponseTimeout.bind(this), MESSAGE_ACK_TIMEOUT);
  },

  onAckChatMessage: function() {
    this.resetAckMessageTimeout();
    this.resetResponseMessageTimeout();

    this.sentOfflineMessage = null;
    this.responseMessageTimeoutId = setTimeout(this.onMessageResponseTimeout.bind(this), AI_RESPONSE_TIMEOUT);
  },

  onMessageResponseTimeout: function() {
    this.chatBotMessagesQueue.push({
      message: 'There was trouble sending your message to our chat service. Please try to resend it once again in few moments.',
      from: 'AI',
      summary: {},
      display_chat_message: true
    });
    this.popChatBotMessage();
    this.chatMessageInput.val(this.sentOfflineMessage);
    this.sentOfflineMessage = null;
    this.inFlightMessage = false; // do not replay chat responses
    this.resetResponseMessageTimeout();
    this.resetAckMessageTimeout();
  },

  resetAckMessageTimeout: function() {
    if (this.ackMessageTimeoutId) {
      clearTimeout(this.ackMessageTimeoutId);
      this.ackMessageTimeoutId = null;
    }
  },

  resetResponseMessageTimeout: function() {
    if (this.responseMessageTimeoutId) {
      clearTimeout(this.responseMessageTimeoutId);
      this.responseMessageTimeoutId = null;
    }
  },

  onChatBotMessageTyped: function() {
    this.chatBotIsTyping = false;
    if (this.chatBotMessagesQueue.length == 0) {
      this.toggleSendMessageControlsAvailability(true);
    } else {
      this.popChatBotMessage();
    }
  },

  popChatBotMessage: function() {
    if (this.chatBotIsTyping || this.chatBotMessagesQueue.length == 0) {
      return;
    }
    this.chatBotIsTyping = true;
    const messageData = this.chatBotMessagesQueue.shift();
    this.appendMessage(messageData.message, messageData.from, true)
        .then(this.onChatBotMessageTyped.bind(this))
        .catch(this.onChatBotMessageTyped.bind(this));
  },

  appendMessage: function(message, from='AI', streamingEffect=false) {
    const lastMessage = this.chatContainer.find('.row:last-child');

    lastMessage.css('padding-bottom', '0');

    if (Array.isArray(message)) {
      message = message.join(); // OpenAI can send more than one message as a reply
    }
    if (message.match(/(<([^>]+)>)/i)) {
      streamingEffect = false;
    }

    const aiMessage = from.toLowerCase() === 'ai';
    const messageOriginator = aiMessage ? 'recipient' : 'sender'
    const senderName = aiMessage ? 'Rachel' : 'You'
    const imageUrl = aiMessage ? UC.constants.chatBotProfileUrl : UC.constants.userProfileUrl

    // remove 'typing' message
    this.$el.find('.typing-dots').closest('.row').remove();

    const $message = $(this.liveChatMessageTemplate({
      messageOriginator: messageOriginator,
      senderName: senderName,
      messageText: streamingEffect ? message.charAt(0) : message,
      userImageUrl: imageUrl,
      typingAnimation: message == 'typing'
    }));

    return new Promise(function(resolve, reject) {
      try {
        this.chatContainer.append($message);
        if (streamingEffect) {
          this.typeTextMessage(message, $message.find('.chat-item-content-message')[0], 1, 0, resolve);
          this.autoResizeInputTextArea();
        } else {
          resolve();
          this.scrollChatToEnd();
        }
      } catch(e) {
        console.warn(e);
        reject();
      }
    }.bind(this));
  },

  typeTextMessage: function(message, streamingTextElement, currentIndex, lastHeight, resolve) {
    if (currentIndex >= message.length) {
      resolve(message);
      return;
    }

    let idx = message.indexOf(' ', currentIndex);
    if (idx < 0) {
      idx = message.length - 1;
    }

    streamingTextElement.textContent += message.substring(currentIndex, idx + 1);
    currentIndex = idx;
    const height = streamingTextElement.getBoundingClientRect().height;
    if (lastHeight == 0 || height > lastHeight) {
      this.scrollChatToEnd();
    }
    lastHeight = height;
    setTimeout(function() {
      this.typeTextMessage(message, streamingTextElement, currentIndex + 1, lastHeight, resolve);
    }.bind(this), 50); // Adjust the typing speed by changing the delay (in milliseconds)
  },

  autoResizeInputTextArea: function() {
    const textarea = this.chatMessageInput;
    const lastMessage = this.chatContainer.find('.row:last-child');

    // To calculate the actual content height
    textarea.css('height', 'auto');

    // 196px is the maximum height before scrolling starts
    let newHeight = Math.min(textarea.prop('scrollHeight'), 196);

    // Set the new height based on content size or the max height allowed
    textarea.css('height', `${newHeight}px`);

    // Calculate and adjust bottom padding based on the new height
    const minHeight = 28 + 10;  // single line height + 10 to adjust for padding
    const currentHeightIncrease = newHeight - minHeight;
    const maximumHeightIncrease = 196 - minHeight;
    let marginBottom = 0;
    if (currentHeightIncrease > 0) {
        marginBottom = (currentHeightIncrease / maximumHeightIncrease) * 125; // Scale padding up to 125px
    }

    // Apply calculated padding to the last message to ensure spacing
    lastMessage.css('padding-bottom', `${marginBottom}px`);

    // Enable scrolling if textarea is more than one line
    if (newHeight >= minHeight) {
        textarea.css('overflow-y', 'auto');
    }

    if (newHeight === minHeight) {
        textarea.css('overflow-y', 'hidden');
    }

    this.scrollChatToEnd();
  },

  toggleSendMessageControlsAvailability: function(available) {
    $('.chat-bot-text-area').find('button').prop('disabled', available ? null : 'disabled')
  },

  sendUserMessage: function(message) {
    this.appendMessage(message, 'User');
    this.appendMessage('typing')
    this.chatChannel.sendMessage(message);
  },

  sendMessageButtonClicked: function(e) {
    e.preventDefault();
    const inputValue = this.chatMessageInput.val();
    if (!inputValue.length) {
      return;
    }
    this.sendUserMessage(inputValue.trim());
    this.chatMessageInput.val('');
    this.autoResizeInputTextArea();
    this.scrollChatToEnd();
    this.toggleSendMessageControlsAvailability(false);
  },

  handleEnterPress: function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (!$('#send-message-button').prop('disabled')) {
        this.sendMessageButtonClicked(event);
        this.$('#send-message-button').click();
      }
    }
  },

  valueDefined: function(value) {
    return value &&
        value.toLowerCase() !== "unspecified" &&
        value.toLowerCase() !== "undefined" &&
        value.toLowerCase() !== "unprovided" &&
        value.length > 0;
  },

  updateSidebar: function(summary) {
    this.jobSummary = summary;

    if (summary.progress) {
      $('#job-progress').css('width', summary.progress + '%');
      $('#job-progress-value').html(summary.progress + '%');
    }

    if (summary.progress > 40 && summary.progress < 59) {
      $('#job-progress-label').html('Few more details needed')
    } else if (summary.progress > 59 && summary.progress < 65) {
      $('#job-progress-label').html('Halfway there')
    } else if (summary.progress > 66 && summary.progress < 89) {
      $('#job-progress-label').html('Nearly there')
    } else if (summary.progress > 92) {
      $('#job-progress-label').html('Preview & Post a Job')
    }

    if (this.valueDefined(summary.zip_code) && this.jobLocation != summary.zip_code) {
      this.jobLocation = summary.zip_code;
      const validationPath = '{0}{1}'.format(this.routes.validZipCode, summary.zip_code);
      const validationParams = {job_lead_id: UC.constants.jobLeadId};
      if (this.valueDefined(summary.legal_subject)) {
        validationParams.legal_subject = summary.legal_subject;
      }

      UC.net.get(validationPath, validationParams, function(res) {
        this.$zipCode.val(summary.zip_code).parent().removeClass('hidden');

        $('#job-location').text(`${res.zip.CityName}, ${res.zip.StateAbbr}`).removeClass('hidden');
        this.$zipCode.closest('.has-error').removeClass('has-error');
        if (res.suggested_attorneys) {
          $('.row.face-piles').replaceWith(res.suggested_attorneys);
        }
      }.bind(this)).fail(function(res) {
        res.handled = true;
        this.$zipCode.val(summary.zip_code).parent().removeClass('hidden');
        UC.utils.showValidationErrors(
          [
            {
              element: this.$zipCode,
              text: res.responseJSON ? res.responseJSON.message : 'Failed to validate the Zip Code'
            }
          ], { className: "form-group" }
        );
      }.bind(this));
    }

    if (this.valueDefined(summary.title)) {
      $('#job-title').html(summary.title);
    } else if (this.valueDefined(summary.legal_subject)) {
      $('#job-title').html(summary.legal_subject);
    }
    if (this.valueDefined(summary.description)) {
      $('#job-description').html(summary.description);
      $('#job-description').val(summary.description);
      this.descriptionLengthCounter.update();
      this.activateChatBotSummary();
    }

    if (this.valueDefined(summary.legal_area)) {
      $('#job-legal-area').html(summary.legal_area).removeClass('hidden');
    }
    if (this.valueDefined(summary.legal_subject)) {
      $('#job-legal-subject').html(summary.legal_subject).removeClass('hidden');
    }
    if (this.jobSummaryAvailable()) {
      this.showSummary();
    }
  },

  jobSummaryAvailable: function() {
    return this.jobSummary != null &&
      this.valueDefined(this.jobSummary.description) &&
        this.valueDefined(this.jobSummary.title) &&
        this.valueDefined(this.jobSummary.zip_code);
  },

  previewSummaryLinkClicked: function(e) {
    e.preventDefault();

    $('#job-summary-panel').removeClass('hidden-xs hidden-sm');
    $('#chat-bot-panel').addClass('hidden');

    this.scrollChatToEnd();
  },

  hideSummaryLinkClicked: function(e) {
    if (e) {
      e.preventDefault();
    }

    $('#job-summary-panel').addClass('hidden-xs hidden-sm');
    $('#chat-bot-panel').removeClass('hidden');

    this.scrollChatToEnd();
    this.autoResizeInputTextArea();
  },

  activateChatBotSummary: function() {
    $('#summary-button-group').addClass('active');
    $('#nextButton').removeClass('btn-default').addClass('btn-success');
  },

  scrollChatToEnd: function() {
    // if (UC.utils.isMobileViewPort()) {
    //   // $('#chat-bot-panel')[0].scrollIntoView({block: "end", inline: "nearest"});
    //   $('.chat-bot-conversation').scrollIntoView({block: "end", inline: "nearest"});
    // } else {
      const chatContainer = $('.chat-bot-conversation');
      chatContainer.stop().animate({
        scrollTop: chatContainer.prop('scrollHeight')
      }, 500);
    // }
  },

  showSummary: function() {
    $('#chat-bot-panel').removeClass('col-md-offset-2 col-lg-offset-2', 500, function() {
      $('#job-summary-panel').removeClass('hidden');
      $('#preview-summary-link').parent().removeClass('hidden');
    });
  },

  captureThreadConversation: function() {
    var messages = [];

    $('.chat-bot-conversation .row').each(function() {
        var role = $(this).hasClass('recipient') ? 'recipient' : 'sender';
        var message = $(this).find('.chat-item-content-message').text().trim();
        messages.push({ role: role, message: message });
    });

    return messages;
  },

  validate: function(dfd) {
    this.$el.find('.has-error').removeClass('has-error');

    var errors = [];

    const data = {
      live_chat: {
        zip_code: this.$zipCode.val(),
        description: $('#job-description').val(),
        thread_conversation: this.captureThreadConversation(),
      }
    }

    if (!this.descriptionLengthCounter.hasValidTextLength()) {
      errors.push(this.descriptionLengthCounter.getError());
    }

    if (errors.length === 0) {
      if (!data.live_chat.zip_code || data.live_chat.zip_code.length === 0) {
        errors.push({element: this.$zipCode, text: 'Please enter a valid zip code.'});
      } else if (UC.utils.validateZipCode(data.live_chat.zip_code)) {
        this.checkZipCodeValid(data, dfd);
        return;
      } else {
        errors.push({element: this.$zipCode, text: 'Please enter a valid zip code.'});
      }
    }

    if (errors.length > 0) {
      UC.utils.showValidationErrors(errors, { className: "form-group" });
      dfd.reject();
    } else {
      if (this.jobSummary) {
        this.jobSummary.zip_code = data.live_chat.zip_code;
        this.jobSummary.description = data.live_chat.description;
        this.jobSummary.thread_conversation = data.live_chat.thread_conversation;
      }

      dfd.resolve({ live_chat: this.jobSummary });
    }
  },

  onZipCodeChanged: function(e) {
    let errors = [];

    this.$zipCode.closest('.has-error').removeClass('has-error');

    $('#job-location').addClass('hidden');

    if (UC.utils.validateZipCode(this.$zipCode.val())) {
      this.checkZipCodeValid({ live_chat: { zip_code: this.$zipCode.val() } }, new $.Deferred());
    } else {
      errors.push({element: this.$zipCode, text: 'Please enter a valid zip code.'});
    }
  },

  checkZipCodeValid: function (data, dfd) {
    const path = '{0}{1}'.format(this.routes.validZipCode, data.live_chat.zip_code);

    UC.net.get(path, {job_lead_id: UC.constants.jobLeadId}, function(res) {
      $('#job-location').text(`${res.zip.CityName}, ${res.zip.StateAbbr}`).removeClass('hidden');
      if (res.suggested_attorneys) {
        $('.row.face-piles').replaceWith(res.suggested_attorneys);
      }
      new GeoLocation().storeUserChoice(data.live_chat.zip_code);
      dfd.resolve(data);
    }).fail(function(res) {
      res.handled = true;
      UC.utils.showValidationErrors(
        [
          {
            element: this.$zipCode,
            text: res.responseJSON ? res.responseJSON.message : 'Failed to validate the Zip Code'
          }
        ], { className: "form-group" }
      );
      dfd.reject();
    }.bind(this));
  },
});
